import { usePrenuvoStore } from '@/stores/usePrenuvoStore';
import { Slot } from '@/types';
import { useShallow } from 'zustand/react/shallow';
import { AvailabilitySlot } from './AvailabilitySlot';
import { useHandleSlots } from '@/hooks';

interface SlotBoxesProps {
  slots: Slot[];
}

const SlotSelectionGrid = ({ slots }: SlotBoxesProps) => {
  const { eventId, machineId, setSelectedSlot, clearScan } = usePrenuvoStore(
    useShallow((state) => ({
      setSelectedSlot: state.scan.methods.setSlot,
      clearScan: state.scan.methods.clearScan,
      eventId: state.scan.eventId,
      machineId: state.scan.machineId,
    })),
  );
  const { removeHoldEventAndClearSession } = useHandleSlots();

  const onSlotClick = async (slot: Slot, isActive: undefined | boolean) => {
    if (eventId) {
      await removeHoldEventAndClearSession(eventId, machineId);
      clearScan();
    }

    if (isActive) {
      clearScan();
      return;
    }

    setSelectedSlot(slot);
  };

  return (
    <div className="sm:px-3 sm:pb-3">
      <div className="grid grid-cols-2 gap-2 text-center lg:grid-cols-3">
        {slots.map((slot, index) => (
          <AvailabilitySlot key={index} slot={slot} index={index} onSlotClick={onSlotClick} />
        ))}
      </div>
    </div>
  );
};

export default SlotSelectionGrid;
